import styled from 'styled-components';
import Box from '@mui/material/Box';
import THEME from '../../../constants/theme';
import { BORDER_COLOR } from '../../FlowDetailsPage/constant';

const StyledStepLink = styled.a`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-radius: 8px;
  min-height: 74px;
  cursor: pointer;
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};
  transition: 0.25s;
  &:hover {
    background: ${THEME.greyColors.grey14};
  }

  &.step:last-child {
    border-bottom: none;
  }

  .title {
    /* color: ${({ disabled }) => (disabled ? THEME.greyColors.grey1 : THEME.primaryColors.black)}; */
  }
`;

const AutomationBox = styled.div`
  width: 100%;

  ${({ completed }) =>
    completed &&
    `
    display: flex;
    align-items: center;
  `}
  /* padding: 24px; */
  border-bottom: 1px solid ${BORDER_COLOR};

  >* {

    >* {
      &:nth-child(3) {
        flex-shrink: 0;
        justify-self: flex-end;
      }

      p {
        max-width: 440px;
      }
    }
  }
  /* cursor: pointer;
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};
  transition: 0.25s;
  &:hover {
    background: ${THEME.greyColors.grey14};
  }

  &.step:last-child {
    border-bottom: none;
  }

  .title {
    color: ${({ disabled }) => (disabled ? THEME.greyColors.grey1 : THEME.primaryColors.black)};
  } */
`;

const IconContainer = styled.div`
  padding: 6px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 18px;
`;

const CheckedStatusBox = styled(Box)`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: ${THEME.secondaryColors.greenDark};
`;

export { StyledStepLink, IconContainer, AutomationBox, CheckedStatusBox };
